import { Flex, Text } from "@chakra-ui/react";

function AppFooter({ version, environment }) {
  if (!version || !environment) return null;

  return (
    <Flex
      as="footer"
      justify="center"
      align="center"
      py={3}
      borderTopWidth="1px"
      borderColor="gray.100"
      bg="white"
      mt="auto"
      flexShrink={0}
    >
      <Text fontSize="xs" color="gray.400">
        Pinpoint v{version} &middot; {environment}
      </Text>
    </Flex>
  );
}

export default AppFooter;
